<template>
  <div>
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">키오스크 관리</h1>
      </div>
      <!--  검색 창  -->
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col2">
                <dd>
                  <label>사업장/거점</label>
                  <ul>
                    <li>
                      <kendo-multicolumncombobox
                          class='w100'
                          ref="facilityAreaRef"
                          :data-source="dataSourceArray"
                          :data-text-field="'facilityAndArea'"
                          :data-value-field="'cdId'"
                          :placeholder="'사업장 / 거점 선택'"
                          :value="lastRouteParams.area"
                          @change="commonOnChangeEvent"
                      >
                        <kendo-multicolumncombobox-column
                            :title="'사업장'"
                            :field="'facility'"
                        ></kendo-multicolumncombobox-column>
                        <kendo-multicolumncombobox-column
                            :title="'거점'"
                            :field="'area'"
                        ></kendo-multicolumncombobox-column>
                      </kendo-multicolumncombobox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>키오스크 사용여부</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="kioskUseYnRef"
                          :index="0"
                          :value="lastRouteParams.kioskUseYn"
                          :style="{width: '100%', border: '0'}"
                          @select="commonOnChangeEvent"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '사용', '미사용']"
                            v-bind:key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>키오스크 명</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="kioskNameRef"
                          :value="lastRouteParams.kioskName"
                          :placeholder="'키오스크 명 입력'"
                          class='w100'
                          id="kioskName"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>무인 보관함 사용여부</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="lockerUseYnRef"
                          :index="0"
                          :value="lastRouteParams.lockerUseYn"
                          :style="{width: '100%', border: '0'}"
                          @select="commonOnChangeEvent"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '사용', '미사용']"
                            v-bind:key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
          <!--          검색필터 끝-->
        </div>
      </div>
      <!--  버튼 영역  -->
      <div v-if="isSU" class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
          <button class="mid_btn orange mr5" @click="onClickKioskSave"><span><span class="k-icon k-i-plus"></span>키오스크 등록</span></button>
        </div>
      </div>
      <!--  리스트 영역 -->
      <kendo-grid
          ref="kioskGridRef"
          id="grid"
          style="cursor: pointer;"
          class="basic_table mt10"
          :data-source="kioskDataSource"
          :columns="kioskListColumns"
          :dataBound= "onDataBoundForUseYnTemplateGrid"
          :navigatable="true"
          :filterable="false"
          :sortable="true"
          :scrollable="true"
          :pageable-always-visible="true"
          :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
          :reorderable="true"
          :column-menu="false"
          :resizable="true"
          :selectable="'multiple row'"
          @change="onChangeGrid"
          :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
  </div>
</template>
<script>
import ApiConfig from "@/api/api.config";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery"
import Apiconfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "KioskList",
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    // 페이지 로딩 시 호출
    this.getKioskList()
    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'kioskName'
    ]
    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }

    for (let i = 0; i < this.zone1DepthList.length; i++) {
      const zone1Depth = this.zone1DepthList[i].cdId
      const zone2DepthList = this.zone2DepthMap.get(zone1Depth) === undefined ? [{cdNm: '기타'}] : this.zone2DepthMap.get(zone1Depth)
      for (let j = 0; j < zone2DepthList.length; j++) {
        this.dataSourceArray.push({
            facilityAndArea: this.zone1DepthList[i].cdNm +' / '+zone2DepthList[j].cdNm,
            facility: this.zone1DepthList[i].cdNm,
            area: zone2DepthList[j].cdNm,
            cdId: zone2DepthList[j].cdId
        })
      }
    }
  },
  methods: {
    // 리스트 api 호출
    getKioskList() {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10

      vm.kioskDataSource = new kendo.data.DataSource({
        name: 'kioskDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap(options, operation) {
            if (operation === 'read') {
              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                area: paramToKendoFilters.area,
                kioskUseYn: paramToKendoFilters.kioskUseYn,
                lockerUseYn: paramToKendoFilters.lockerUseYn,
                kioskNm: paramToKendoFilters.kioskName,
                requestType: 'PAGING'
              }
              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }
            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.kioskGridRef.dataSource.page() - 1) * vm.$refs.kioskGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }
            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              row.rowNumber = rowNumber--
            }
            response.resultData = changeResultData
            return response
          },
          total(response) {
            return response.total
          },
          data(response) {
            if (response.resultStatus.messageCode === '2000') {
              vm.kioskInfo = response.resultData
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return false
            }
          }
        },
        error(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    // 검색 조건
    currentPageFilterOption() {
      const vm = this
      const refs = vm.$refs

      const currentSearchDataObj = {}

      if (refs.facilityAreaRef !== undefined) {
        const area = refs.facilityAreaRef.kendoWidget().value()
        if (area !== null && area !== '') {
          currentSearchDataObj.area = area
        }
      }

      if (refs.kioskUseYnRef !== undefined) {
        const kioskUseYn = refs.kioskUseYnRef.kendoWidget().current().index()
        if (kioskUseYn !== '' && kioskUseYn !== null) {
          let resultKioskUseYn
          if (kioskUseYn === 0) {
            resultKioskUseYn = ''
          } else if (kioskUseYn === 1) {
            resultKioskUseYn = 'Y'
          } else if (kioskUseYn === 2) {
            resultKioskUseYn = 'N'
          }
          currentSearchDataObj.kioskUseYn = resultKioskUseYn
        }
      }

      if (refs.kioskNameRef !== undefined) {
        const kioskName = refs.kioskNameRef.kendoWidget().value().trim()
        if (kioskName !== null && kioskName !== '') {
          currentSearchDataObj.kioskName = kioskName
        }
      }

      if (refs.lockerUseYnRef !== undefined) {
        const lockerUseYn = refs.lockerUseYnRef.kendoWidget().current().index()
        if (lockerUseYn !== '' && lockerUseYn !== null) {
          let resultLockerUseYn
          if (lockerUseYn === 0) {
            resultLockerUseYn = ''
          } else if (lockerUseYn === 1) {
            resultLockerUseYn = 'Y'
          } else if (lockerUseYn === 2) {
            resultLockerUseYn = 'N'
          }
          currentSearchDataObj.lockerUseYn = resultLockerUseYn
        }
      }
      return currentSearchDataObj
    },
    // 검색 버튼 호출
    commonOnChangeEvent() {
      const vm = this
      const gridRefs = this.$refs.kioskGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    // 초기화 버튼
    cleanFilter() {
      const vm = this
      const refs = vm.$refs

      if (refs.facilityAreaRef !== undefined) {
        refs.facilityAreaRef.kendoWidget().value('')
      }
      if (refs.kioskUseYnRef !== undefined) {
        refs.kioskUseYnRef.kendoWidget().select(0)
      }
      if (refs.lockerUseYnRef !== undefined) {
        refs.lockerUseYnRef.kendoWidget().select(0)
      }
      if (refs.kioskNameRef !== undefined) {
        refs.kioskNameRef.kendoWidget().value('')
      }
      vm.getKioskList()
    },
    // 그리드 선택시 셀벨로 해당 페이지로 이동
    onChangeGrid(e) {
      const vm = this
      const selectedRow = e.sender.select()
      const selectedIndex = e.sender._lastCellIndex
      const kioskNo = e.sender.dataItem(selectedRow).kioskNo
      const facility = e.sender.dataItem(selectedRow).facility

      if(selectedIndex === 11) {
        vm.onClickEmergencySettings(kioskNo)
      }
      else if(selectedIndex === 12) {
        vm.onClickPromotionSettings(kioskNo)
      }
      else {
        vm.onClickKioskDetail(kioskNo)
      }
    },
    // 등록으로 이동
    onClickKioskSave() {
      const vm = this
      vm.$router.push({
        name: 'KioskSave'
      })
    },
    // 키오스크 상세 설정 이동
    onClickKioskDetail(kioskNo) {
      const vm = this
      vm.$router.push({
        name: 'KioskDetail',
        params: {
          kioskNo: kioskNo
        }
      })
    },
    accessKiosk(kioskNo){
      const vm = this
      const kioskList = vm.loginUserData.kioskNo?vm.loginUserData.kioskNo.replaceAll(' ','').split(','):[]
      return !vm.isSU && !kioskList.includes(kioskNo)
    },
    // 긴급공지 설정 이동
    onClickEmergencySettings(kioskNo) {
      const vm = this
      if(vm.accessKiosk(kioskNo)){
        kendo.alert('키오스크 담당자만 수정 가능합니다.')
        return false
      }
      vm.$router.push({
        name: 'EmergencySettings',
        params: {
          kioskNo: kioskNo
        }
      })
    },
    // 프로모션 설정 이동
    onClickPromotionSettings(kioskNo) {
      const vm = this
      if(vm.accessKiosk(kioskNo)){
        kendo.alert('키오스크 담당자만 수정 가능합니다.')
        return false
      }
      vm.$router.push({
        name: 'PromotionSettings',
        params: {
          kioskNo: kioskNo
        }
      })
    },
    // 켄도 그리드 안에 kendo-switch 바운드
    onDataBoundForUseYnTemplateGrid: function (evt) {
      let grid = evt.sender
      let items = evt.sender.items()

      items.each(function () {
        let dataItem = grid.dataItem(this)
        let noticeTitle = kendo.jQuery(this).find('span[name=noticeTitle]')
        let promotionCnt = kendo.jQuery(this).find('span[name=promotionCnt]')
        kendo.jQuery(noticeTitle).text(dataItem.noticeTitle)
        kendo.jQuery(promotionCnt).text(dataItem.promotionCount)
      })
    },

  },
  data: function () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
    const isSU = loginUserData.authId === '9999'
    const vm = this
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      isSU: isSU,
      dataSourceArray: [],
      lastRouteParams: [],
      kioskDataSource: [],
      kioskInfo: [],
      kioskListColumns: [
        {
          field: 'rowNumber',
          title: 'No.',
          width: '3%',
          sortable: false
        },
        {
          field: 'frstRgstDt',
          title: '생성 일시',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'lastMdfyDt',
          title: '수정 일시',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'kioskNm',
          title: '키오스크 명',
          width: '11%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter txt_s'
          },
        },
        {
          field: 'facilityNm',
          title: '사업장',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'areaNm',
          title: '거점',
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'buildingNm',
          title: '건물',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'floorNm',
          title: '층',
          width: '4%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
             field: 'lockerUseYn',
             title: '무인 보관함',
             width: '5%',
             headerAttributes: kendoGridHeaderAttributes,
             attributes: {
               class: 'tcenter'
             },
             template(dataItem){
               if (dataItem.lockerUseYn == 'Y'){
                 return dataItem.useYn = "사용"
               }
               if (dataItem.lockerUseYn == 'N'){
                 return dataItem.useYn = "-"
               }
             },
           },
        {
          field: 'kioskUseYn',
          title: '사용여부',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem){
            if (dataItem.kioskUseYn == 'Y'){
              return dataItem.useYn = "사용"
            }
            if (dataItem.kioskUseYn == 'N'){
              return dataItem.useYn = "미사용"
            }
          },
        },
        {
          field: 'lastVersionNm',
          title: '버전 정보',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem){
            if (!!!dataItem.updateVersionNm){
              return `<span class="f_s">현재 버전 </span><div>${dataItem.lastVersionNm}</div>`
            }
            else if (dataItem.lastVersionNm === dataItem.updateVersionNm){
              return `<div class="">${dataItem.lastVersionNm}</div><div class="process08 process_icon mgt5">완료</div>`
            }
            else if (dataItem.lastVersionNm !== dataItem.updateVersionNm){
              return `<div class="">${dataItem.lastVersionNm}</div><div class="process01 process_icon mgt5">필요</div>`
            }
          },
        },
        {
          field: '',
          title: '긴급공지 설정',
          width: '12%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          command: [
            {
              name : "emergencyNotice",
              template : '<span class="txt_b">[긴급공지] </span><span name="noticeTitle"></span></br><a class="mid_btn mgt10 k-grid-emergencyNotice">수정</a>',
              click: function (e) {
                e.preventDefault();
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                vm.onClickEmergencySettings(selectedRow.kioskNo)
              },
              visible: function (dataItem){
                return (dataItem.emergencyNoticeYn === 'Y' && dataItem.noticeExpiredYn === 'N')
              },
            },
            {
              name: "emergencyNotice_N",
              template : `<a class="mid_btn green mgt5 k-grid-emergencyNotice_N">등록</a>`,
              click: function (e) {
                e.preventDefault();
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                vm.onClickEmergencySettings(selectedRow.kioskNo)
              },
              visible: function (dataItem){
                return !(dataItem.emergencyNoticeYn === 'Y' && dataItem.noticeExpiredYn === 'N')
              },
            },
          ]
        },
        {
          field: '',
          title: '프로모션 설정',
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          command: [
            {
              name: "promotion_N",
              template : `<div class="process02 process_icon">프로모션 <span name="promotionCnt"></span>건</div><br><a class="mid_btn mgt10 k-grid-promotion_N">수정</a>`,
              click: function (e) {
                e.preventDefault();
                let tr = $(e.target).closest('tr')
                const selectedRow = this.dataItem(tr)
                vm.onClickPromotionSettings(selectedRow.kioskNo)
              },
              visible: function (dataItem){
                return (dataItem.promotionUseYn === 'Y')
              },
            },
            {
            name: "promotion_Y",
            template : `<a class="mid_btn green k-grid-promotion_Y">등록</a>`,
            click: function (e) {
              e.preventDefault();
              let tr = $(e.target).closest('tr')
              const selectedRow = this.dataItem(tr)
              vm.onClickPromotionSettings(selectedRow.kioskNo)
            },
              visible: function (dataItem){
                return !(dataItem.promotionUseYn === 'Y')
              },
            },
          ]
        },
    ]
    }
  }
}
</script>
